import React, { useState } from 'react';

function SettingsPanel({ onClose }) {
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'dark');
  const [fontSize, setFontSize] = useState(localStorage.getItem('fontSize') || 'medium');
  const [apiKey, setApiKey] = useState('');
  
  const changeTheme = (newTheme) => {
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.body.className = newTheme;
  };
  
  const changeFontSize = (size) => {
    setFontSize(size);
    localStorage.setItem('fontSize', size);
    document.body.setAttribute('data-font-size', size);
  };
  
  const runSystemCheck = () => {
    const checks = {
      localStorage: typeof localStorage !== 'undefined',
      clipboard: typeof navigator.clipboard !== 'undefined',
      fileReader: typeof FileReader !== 'undefined',
      fetch: typeof fetch !== 'undefined'
    };
    
    const total = Object.keys(checks).length;
    const passed = Object.values(checks).filter(v => v).length;
    
    alert(`System Check:\n${passed}/${total} features available\n\n` + 
      Object.entries(checks).map(([k, v]) => `${k}: ${v ? '✅' : '❌'}`).join('\n'));
  };
  
  return (
    <div className="settings-overlay" onClick={onClose}>
      <div className="settings-panel" onClick={(e) => e.stopPropagation()}>
        <div className="settings-header">
          <h2>⚙️ Settings</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        
        <div className="settings-content">
          <div className="setting-group">
            <label>Theme</label>
            <div className="setting-buttons">
              <button 
                className={theme === 'dark' ? 'active' : ''}
                onClick={() => changeTheme('dark')}
              >
                🌙 Dark
              </button>
              <button 
                className={theme === 'light' ? 'active' : ''}
                onClick={() => changeTheme('light')}
              >
                ☀️ Light
              </button>
            </div>
          </div>
          
          <div className="setting-group">
            <label>Font Size</label>
            <div className="setting-buttons">
              <button 
                className={fontSize === 'small' ? 'active' : ''}
                onClick={() => changeFontSize('small')}
              >
                Small
              </button>
              <button 
                className={fontSize === 'medium' ? 'active' : ''}
                onClick={() => changeFontSize('medium')}
              >
                Medium
              </button>
              <button 
                className={fontSize === 'large' ? 'active' : ''}
                onClick={() => changeFontSize('large')}
              >
                Large
              </button>
            </div>
          </div>
          
          <div className="setting-group">
            <label>API Key (Together AI)</label>
            <input 
              type="password" 
              placeholder="Enter new API key..."
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              className="api-key-input"
            />
            <small>Current key is stored in aiService.js</small>
          </div>
          
          <div className="setting-group">
            <button className="system-check-btn" onClick={runSystemCheck}>
              🔍 Run System Check
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SettingsPanel;
